import { Box } from "@moonpig/launchpad-components";

export const Spacer = () => <Box height={64} />;
